import React from "react";
var __jsx = React.createElement;
import { useCallback, useEffect, useRef, useState } from "react";
var DEFAULT_RESET_MS = 1500;

/** Writes text to the clipboard when the API is available. */
function writeClipboard(value) {
  if (value && typeof navigator !== "undefined" && navigator.clipboard) {
    return navigator.clipboard.writeText(value);
  }
  return Promise.resolve();
}

/**
 * Headless wrapper that owns copy-to-clipboard behaviour and exposes
 * `{ copied, copy }` to a render function, leaving all markup to the caller.
 */
export function CopyToClipboard(_ref) {
  var value = _ref.value,
    _ref$resetMs = _ref.resetMs,
    resetMs = _ref$resetMs === void 0 ? DEFAULT_RESET_MS : _ref$resetMs,
    children = _ref.children;
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  var timeoutRef = useRef();
  useEffect(function () {
    return function () {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  var copy = useCallback(function () {
    writeClipboard(value).then(function () {
      setCopied(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(function () {
        return setCopied(false);
      }, resetMs);
    });
  }, [value, resetMs]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    copied: copied,
    copy: copy
  }));
}